import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderTranslateService {
  constructor(private translate: TranslateService) {}

  translateWorkOrderState(workOrderState: string) {
    let translatedState = '';
    switch (workOrderState) {
      case 'Unassigned':
        this.translate.get('workorder.details.unassigned').subscribe((res: string) => {
          translatedState = res;
        });
        break;
      case 'Assigned':
        this.translate.get('workorder.details.assigned').subscribe((res: string) => {
          translatedState = res;
        });
        break;
      case 'Working':
        this.translate.get('workorder.details.working').subscribe((res: string) => {
          translatedState = res;
        });
        break;
      case 'Finished':
        this.translate.get('workorder.details.finished').subscribe((res: string) => {
          translatedState = res;
        });
        break;
      case 'Validated':
        this.translate.get('workorder.details.validated').subscribe((res: string) => {
          translatedState = res;
        });
        break;
      default:
        break;
    }

    return translatedState;
  }

  translateDrawerConfirmButton(buttonName: string) {
    let translatedButton = '';
    switch (buttonName) {
      case 'Save':
        this.translate.get('workorder.drawer-actions.save').subscribe((res: string) => {
          translatedButton = res;
        });
        break;
      case 'Yes':
        this.translate.get('workorder.drawer-actions.yes').subscribe((res: string) => {
          translatedButton = res;
        });
        break;
      case 'Finish':
        this.translate.get('workorder.drawer-actions.finish').subscribe((res: string) => {
          translatedButton = res;
        });
        break;
      default:
        break;
    }

    return translatedButton;
  }

  translateDrawerTitle(title: string) {
    let translatedTitle = '';
    switch (title) {
      case 'Manage Visits':
        this.translate.get('workorder.drawer-title.manage-visits').subscribe((res: string) => {
          translatedTitle = res;
        });
        break;
      case 'Create Visit':
        this.translate.get('workorder.drawer-title.create-visit').subscribe((res: string) => {
          translatedTitle = res;
        });
        break;
      case 'Edit Visit':
        this.translate.get('workorder.drawer-title.edit-visit').subscribe((res: string) => {
          translatedTitle = res;
        });
        break;
      case 'Finish Visit':
        this.translate.get('workorder.drawer-title.finish-visit').subscribe((res: string) => {
          translatedTitle = res;
        });
        break;
      case 'Validate Work Order':
        this.translate.get('workorder.drawer-title.accept-workorder').subscribe((res: string) => {
          translatedTitle = res;
        });
        break;
      case 'Reject Work Order':
        this.translate.get('workorder.drawer-title.reject-workorder').subscribe((res: string) => {
          translatedTitle = res;
        });
        break;
      default:
        break;
    }

    return translatedTitle;
  }

  translateAbbreviatedEmployees(employeeNumber: number) {
    let translatedNames = '';
    this.translate
      .get('workorder.employee-visits.abbreviated-employees', { employeeNumber: employeeNumber })
      .subscribe((res: string) => {
        translatedNames = res;
      });

    return translatedNames;
  }

  translateAndCharacter() {
    let translatedChar = '';
    this.translate.get('workorder.details.and-character').subscribe((res: string) => {
      translatedChar = res;
    });

    return translatedChar;
  }

  translateRemoveVisitsMessage() {
    let translatedMsg = '';
    this.translate.get('workorder.confirm-dialog.remove-visits-msg').subscribe((res: string) => {
      translatedMsg = res;
    });

    return translatedMsg;
  }
}
